import React from "react";

import HomeUI from "../../../ui/homeUI/_index";

const EmailAutomaticPage = () => {
  return(
    <HomeUI />
  )
}

export default EmailAutomaticPage;
